export const SET_ACCOUNTING_FIELDS = 'SET_ACCOUNTING_FIELDS';
export class SetAccountingFields {
    constructor(accountingFields) {
        this.type = SET_ACCOUNTING_FIELDS;
        this.payload = accountingFields;
    }
}
